// Lokale Coin-Icons für Coins, die CoinGecko nicht (mehr) als Image liefert.
//
// Hintergrund: Manche Coins werden bei CoinGecko depreciert (z.B. BUSD nach
// Paxos-Einstellung Feb 2024). Der /coins/markets-Endpoint liefert dann zwar
// noch Preis und Marketdaten, aber kein `image`-Feld mehr. In dem Fall
// rendert die App sonst nur eine Buchstaben-Pille — wir hinterlegen das
// Original-Logo statisch im /public/coin-icons/-Ordner.
//
// Pfad ist absichtlich relativ (`/coin-icons/...`) — der Browser löst gegen
// den eigenen Origin auf, für PDF-Server-Rendering wird in exportService.js
// der Origin vorgehängt.

// Symbol → lokaler Pfad. Wird im CoinImage-Komponenten-Fallback verwendet.
export const LOCAL_COIN_ICONS = {
  BUSD: '/coin-icons/busd.png',
};

// CoinGecko-ID → lokaler Pfad. Wird beim Export benötigt, weil marketData
// dort nach CG-ID gekeyt ist (nicht nach Symbol).
export const LOCAL_COIN_ICONS_BY_ID = {
  'binance-usd': '/coin-icons/busd.png',
};
